import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "apt-home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "서울 아파트 실거래가"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "국토교통부 실거래가 기반 서울시 아파트 시장 동향 대시보드")
], -1)
const _hoisted_3 = { class: "home-section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "거래량 · 평균가 추이", -1)
const _hoisted_5 = { id: "seoul-chart-area" }
const _hoisted_6 = { class: "home-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "자치구 랭킹 · 최근 거래", -1)
const _hoisted_8 = { id: "home-bottom-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AptMarketSummary = _resolveComponent("AptMarketSummary")!
  const _component_SeoulTradeStat12Month = _resolveComponent("SeoulTradeStat12Month")!
  const _component_SeoulTradeStat10Year = _resolveComponent("SeoulTradeStat10Year")!
  const _component_SggAvgAmount = _resolveComponent("SggAvgAmount")!
  const _component_RecentTradeFeed = _resolveComponent("RecentTradeFeed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_AptMarketSummary),
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SeoulTradeStat12Month),
        _createVNode(_component_SeoulTradeStat10Year)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_SggAvgAmount),
        _createVNode(_component_RecentTradeFeed)
      ])
    ])
  ]))
}